module.exports = __webpack_public_path__ + "img/company-img.7e772637.png";